import React from "react";

function IconShare(props) {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 .94l3.53 3.53a.75.75 0 01-1.06 1.06l-1.72-1.72v8.64a.75.75 0 01-1.5 0V3.81L7.53 5.53a.75.75 0 01-1.06-1.06L10 .94zM3.25 8A.75.75 0 014 7.25h3a.75.75 0 010 1.5H4.75v9.5h10.5v-9.5H13a.75.75 0 010-1.5h3a.75.75 0 01.75.75v11a.75.75 0 01-.75.75H4a.75.75 0 01-.75-.75V8z",
    clipRule: "evenodd"
  }));
}

export default IconShare;